import apiSetting from '../apiSetting';

const API_URL = process.env.REACT_APP_API_URL || window.APP_CONFIG.REACT_APP_API_URL;

// 取得所有車輛
export const getAllVehicles = async () => {
    return await apiSetting({
        method: 'GET',
        url: `${API_URL}/vehicle/getAllVehicles`,
    });
};

// 根據條件取得車輛
export const getVehicles = async (data) => {
    const queryParams = new URLSearchParams(data).toString();
    return await apiSetting({
        method: 'GET',
        url: `${API_URL}/vehicle/getVehicles?${queryParams}`,
    });
};

// 新增車輛
export const createVehicle = async (vehicleData) => {
    return await apiSetting({
        method: 'POST',
        url: `${API_URL}/vehicle/createVehicle`,
        data: vehicleData,
    });
};

// 更新車輛
export const updateVehicle = async (vehicleId, vehicleData) => {
    return await apiSetting({
        method: 'PATCH',
        url: `${API_URL}/vehicle/updateVehicle`,
        data: vehicleData,
    });
};

// 刪除車輛
export const deleteVehicle = async (vehicleId) => {
    return await apiSetting({
        method: 'DELETE',
        url: `${API_URL}/vehicle/deleteVehicle/${vehicleId}`,
    });
};

// 上傳車輛圖片
export const uploadVehicleImage = async (data, type) => {
    try {
        const response = await apiSetting({
            method: 'POST',
            url: `${API_URL}/vehicle/uploadVehicleImage?vehicleId=${data.vehicleId}&type=${type}`,
            data: data.formData
        });
        return response;
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`);
    }
};
